import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { saveFile } from '../helpers/saveFile';
import { API_ROOT } from '../helpers/apiConfig';

export const actions = {
    loadFilesFilters: (subId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_FILES_FILTERS_REQUEST,
                        types.LOAD_FILES_FILTERS_SUCCESS,
                        types.LOAD_FILES_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadFile: (fileId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/' + fileId,
                    method: 'GET',
                    types: [
                        types.LOAD_FILE_REQUEST,
                        types.LOAD_FILE_SUCCESS,
                        types.LOAD_FILE_FAILURE
                    ]
                }
            });
        }
    },
    saveFile: (request, isVisibleInRepository) => {
        let body = new FormData();
        for (let key in request) {
            body.append(key, request[key]);
        }

        if (request.id === 0) {
            body.append('isVisibleInRepository', isVisibleInRepository);
            return (dispatch) => {
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'files/create',
                        method: 'POST',
                        body: body,
                        types: [
                            types.CREATE_FILE_REQUEST,
                            types.CREATE_FILE_SUCCESS,
                            types.CREATE_FILE_FAILURE
                        ]
                    }
                });
            }
        } else {
            return (dispatch) => {
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'files/update',
                        method: 'POST',
                        body: body,
                        types: [
                            types.UPDATE_FILE_REQUEST,
                            types.UPDATE_FILE_SUCCESS,
                            types.UPDATE_FILE_FAILURE
                        ]
                    }
                });
            }

        }
    },
    saveMultipleNewFiles: (files, commonAttributes) => {
        let body = new FormData();
        for (let i = 0; i < files.length; i++) {
            body.append(files[i].name, files[i].file)
        }

        for (let key in commonAttributes) {
            body.append(key, commonAttributes[key]);
        }
        
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/create-multiple',
                    method: 'POST',
                    body: body,
                    types: [
                        types.CREATE_MULTIPLE_FILES_REQUEST,
                        types.CREATE_MULTIPLE_FILES_SUCCESS,
                        types.CREATE_MULTIPLE_FILES_FAILURE
                    ]
                }
            });
        }
    },
    loadListFilters: (subId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/list-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_FILES_LIST_FILTERS_REQUEST,
                        types.LOAD_FILES_LIST_FILTERS_SUCCESS,
                        types.LOAD_FILES_LIST_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationFileFilters: (locationKey) => {
        return (dispatch) => {

            return dispatch({
                [CALL_API]: {
                    endpoint: `files/location-file-filters/${locationKey}`,
                    method: 'GET',
                    types: [
                        types.LOAD_LOCATION_FILE_FILTERS_REQUEST,
                        types.LOAD_LOCATION_FILE_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_FILE_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationFileTaskFilters: (deptId, projId, locationKey) => {
        return (dispatch) => {
            const body = {
                departmentId: deptId,
                projectId: projId,
                locationKey: locationKey
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/location-file-task-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_LOCATION_FILE_TASK_FILTERS_REQUEST,
                        types.LOAD_LOCATION_FILE_TASK_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_FILE_TASK_FILTERS_FAILURE
                    ]
                }
            });
        }
    },      
    search: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/search',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SEARCH_FILES_REQUEST,
                        types.SEARCH_FILES_SUCCESS,
                        types.SEARCH_FILES_FAILURE
                    ]
                }
            });
        }
    },
    /**
     * Downloading requires access to the raw response and headers, so this function that
     * would typically be an action creator that dispatches a call through the API middleware
     * in api.js is instead directly calling fetch and processing the response with file-saver.js
     */
    download: (fileName, isPublic = false, promptSave = true) => {
        return (dispatch, getState) => {
            const endpoint = isPublic ? 'files/download/public?f=' + fileName : 'files/download?f=' + fileName;
            const method = 'GET';
            let headers = {};
            const token = getState().user.accessToken;
            if (typeof token === "string") {
                headers.Authorization = `Bearer ${token}`;
            }
            const subscriptionId = getState().user.currentSubscriptionId;
            if (subscriptionId) {
                headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
            }

            return (
                // eslint-disable-next-line no-undef
                fetch(`${API_ROOT}${endpoint}`, {
                    method,
                    headers,
                    credentials: "same-origin"
                })
                    .then(async response => {
                        return await saveFile(response, promptSave);
                    })
            );
        }
    },
    deleteFile: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'files/delete',
                    method: 'POST',
                    body: request,
                    types: [
                        types.DELETE_FILE_REQUEST,
                        types.DELETE_FILE_SUCCESS,
                        types.DELETE_FILE_FAILURE
                    ]
                }
            });
        }
    },
}
